module.exports = __webpack_public_path__ + "static/bg04-0f70565904ce590b751dcfc2b5eceaaa.webp";